import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { IcArrowDown, IcSave, IcArrowLeft } from "../../Icons";
import axios from "axios";
import { Button, Input, Label, Row, Col } from "reactstrap";
import Header from "../../layout/Header/Header";
import Swal from "sweetalert2";
import moment from "moment";

const fmt = (v, moneda = "MXN") =>
  new Intl.NumberFormat("es-MX", { style: "currency", currency: moneda }).format(Number(v) || 0);

const num = (v) => Number(v) || 0;

// ── Fórmulas del layout de Excel (el back recalcula lo mismo al guardar) ────
export function calculaEntrada({ formato, monto, regresar, tc, comisionExtra,
                                 comisionProvPorcentaje, comisionPorcentaje }) {
  const cpp = num(comisionProvPorcentaje);
  const cp = num(comisionPorcentaje);

  if (formato === "Transferencia") {
    const r = num(regresar);
    const t = num(tc);
    const ce = num(comisionExtra);
    const comisionProvMonto = ((r * cpp) / 100) * t;
    const comisionMonto = ((r * cp) / 100) * t;
    const totalPesos = (r + ce) * t + comisionProvMonto + comisionMonto;
    return {
      comisionProvMonto,
      comisionMonto,
      comisionTotal: comisionProvMonto + comisionMonto,
      totalPesos,
      regresar: r,
    };
  }

  const m = num(monto);
  const comisionProvMonto = (m * cpp) / 100;
  const comisionMonto = (m * cp) / 100;
  return {
    comisionProvMonto,
    comisionMonto,
    comisionTotal: comisionProvMonto + comisionMonto,
    totalPesos: m,
    regresar: m - comisionProvMonto - comisionMonto,
  };
}

function EntradasCreate() {
  const { user } = useContext(AuthContext);
  const URL_ENTRADAS = process.env.REACT_APP_URL_ENTRADAS;
  const URL_CATEGORIAS = process.env.REACT_APP_URL_CATEGORIAS;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_CUENTAS = process.env.REACT_APP_URL_CUENTAS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const auth = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };

  const [categorias, setCategorias] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [cuentas, setCuentas] = useState([]);

  const [fecha, setFecha] = useState(moment().format("YYYY-MM-DD"));
  const [selectedCategoria, setSelectedCategoria] = useState("");
  const [selectedEmpresa, setSelectedEmpresa] = useState("");
  const [selectedCliente, setSelectedCliente] = useState("");
  const [selectedCuenta, setSelectedCuenta] = useState("");

  const [monto, setMonto] = useState(0);
  const [regresar, setRegresar] = useState(0);
  const [comisionExtra, setComisionExtra] = useState(0);
  const [tc, setTc] = useState(0);
  const [comisionProvPorcentaje, setComisionProvPorcentaje] = useState(0);
  const [comisionPorcentaje, setComisionPorcentaje] = useState(0);
  const [status, setStatus] = useState("Pendiente");
  const [observaciones, setObservaciones] = useState("");
  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios.get(URL_CATEGORIAS, auth).then((r) => setCategorias(r.data)).catch(() => {});
    axios.get(URL_EMPRESAS, auth).then((r) => setEmpresas(r.data)).catch(() => {});
    axios.get(URL_CLIENTES, auth).then((r) => setClientes(r.data)).catch(() => {});
    axios.get(URL_CUENTAS, auth).then((r) => setCuentas(r.data)).catch(() => {});
  }, []); // eslint-disable-line

  const categoria = categorias.find((a) => a._id === selectedCategoria);
  const formato = categoria?.formato || "Directa";
  const esTransferencia = formato === "Transferencia";

  const calc = calculaEntrada({
    formato, monto, regresar, tc, comisionExtra,
    comisionProvPorcentaje, comisionPorcentaje,
  });

  // El aviso del Excel: la comisión extra solo aplica abajo de 10,000 USD
  const avisoComisionExtra = esTransferencia && num(regresar) >= 10000 && num(comisionExtra) > 0;

  function guardar() {
    if (!fecha || !selectedCliente || !selectedCategoria) {
      Swal.fire("Falta información", "Fecha, categoría y cliente son obligatorios", "warning");
      return;
    }
    if (esTransferencia && num(tc) <= 0) {
      Swal.fire("Falta información", "Captura el tipo de cambio", "warning");
      return;
    }
    setValidaBoton(false);

    axios
      .post(URL_ENTRADAS, {
        fecha,
        formato,
        categorias: selectedCategoria,
        empresas: selectedEmpresa || undefined,
        clientes: selectedCliente,
        cuentas: selectedCuenta || undefined,
        monto: num(monto),
        regresar: num(regresar),
        comisionExtra: num(comisionExtra),
        tc: num(tc),
        comisionProvPorcentaje: num(comisionProvPorcentaje),
        comisionPorcentaje: num(comisionPorcentaje),
        status,
        observaciones: observaciones || "NA",
      }, auth)
      .then(() => {
        axios.post(URL_LOGS, {
          tipo: "Crear Entrada",
          detalle: `${clientes.find((a) => a._id === selectedCliente)?.nombre_comercial || ""} ${calc.totalPesos}`,
          user: user.id,
        }, auth);
        Swal.fire("¡Listo!", "Entrada registrada con éxito", "success");
        setTimeout(() => { window.location.href = "/ListadoEntradas"; }, 1200);
      })
      .catch((error) => {
        setValidaBoton(true);
        Swal.fire({
          icon: "error", title: "Oops...", text: "Something went wrong!",
          footer: `${error.response?.data?.message || ""}`,
        });
      });
  }

  return (
    <>
      <Header />
      {user.menu_entradas ? (
        <div className="card container col-12">
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <IcArrowDown style={{ marginRight: 8, color: "#10b981" }} />
                Nueva Entrada
              </h3>
              <p className="page-subtitle">
                {esTransferencia
                  ? "Formato Transferencia: se captura lo que hay que regresar en USD"
                  : "Formato Directa: se captura el monto en pesos y se le restan las comisiones"}
              </p>
            </div>
            <div className="page-actions">
              <Button color="secondary" size="sm" href="/ListadoEntradas">
                <IcArrowLeft style={{ marginRight: 6 }} />
                Regresar
              </Button>
            </div>
          </div>

          {/* ── Datos generales ─────────────────────────────────────────── */}
          <div className="form-section">
            <div className="form-section-header">
              <span className="form-section-title">Datos de la operación</span>
            </div>
            <div className="form-section-body">
              <Row>
                <Col md={3}>
                  <Label>Fecha</Label>
                  <Input type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} />
                </Col>
                <Col md={3}>
                  <Label>Categoría</Label>
                  <Input type="select" value={selectedCategoria}
                         onChange={(e) => setSelectedCategoria(e.target.value)}>
                    <option value="">Selecciona</option>
                    {categorias
                      .filter((a) => a.is_active === "Si")
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => <option key={a._id} value={a._id}>{a.name}</option>)}
                  </Input>
                </Col>
                <Col md={3}>
                  <Label>Empresa</Label>
                  <Input type="select" value={selectedEmpresa}
                         onChange={(e) => setSelectedEmpresa(e.target.value)}>
                    <option value="">Selecciona</option>
                    {empresas
                      .filter((a) => a.is_active === "Si")
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => <option key={a._id} value={a._id}>{a.name}</option>)}
                  </Input>
                </Col>
                <Col md={3}>
                  <Label>Cliente</Label>
                  <Input type="select" value={selectedCliente}
                         onChange={(e) => setSelectedCliente(e.target.value)}>
                    <option value="">Selecciona</option>
                    {clientes
                      .filter((a) => a.is_active === "Si")
                      .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                      .map((a) => <option key={a._id} value={a._id}>{a.nombre_comercial}</option>)}
                  </Input>
                </Col>
              </Row>
              <Row className="mt-2">
                <Col md={3}>
                  <Label>Cuenta</Label>
                  <Input type="select" value={selectedCuenta}
                         onChange={(e) => setSelectedCuenta(e.target.value)}>
                    <option value="">Selecciona</option>
                    {cuentas
                      .filter((a) => a.is_active === "Si")
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => <option key={a._id} value={a._id}>{a.name}</option>)}
                  </Input>
                </Col>
                <Col md={3}>
                  <Label>Estatus</Label>
                  <Input type="select" value={status} onChange={(e) => setStatus(e.target.value)}>
                    <option value="Pendiente">Pendiente</option>
                    <option value="Cobrado">Cobrado</option>
                  </Input>
                </Col>
                <Col md={6}>
                  <Label>Observaciones</Label>
                  <Input type="text" value={observaciones}
                         onChange={(e) => setObservaciones(e.target.value)} />
                </Col>
              </Row>
            </div>
          </div>

          {/* ── Importes ────────────────────────────────────────────────── */}
          <div className="form-section">
            <div className="form-section-header">
              <span className="form-section-title">
                {esTransferencia ? "Importes (USD → MXN)" : "Importes (MXN)"}
              </span>
            </div>
            <div className="form-section-body">
              {esTransferencia ? (
                <>
                  <Row>
                    <Col md={3}>
                      <Label>Regresar (USD)</Label>
                      <Input type="number" value={regresar}
                             onChange={(e) => setRegresar(e.target.value)} />
                    </Col>
                    <Col md={3}>
                      <Label>Comisión Extra (USD)</Label>
                      <Input type="number" value={comisionExtra}
                             onChange={(e) => setComisionExtra(e.target.value)} />
                      <small style={{ color: avisoComisionExtra ? "#dc2626" : "#94a3b8",
                                      fontSize: "0.7rem" }}>
                        Solo aplica abajo de 10,000 USD (25 USD)
                      </small>
                    </Col>
                    <Col md={2}>
                      <Label>TC</Label>
                      <Input type="number" value={tc} onChange={(e) => setTc(e.target.value)} />
                    </Col>
                    <Col md={2}>
                      <Label>Comisión Prov %</Label>
                      <Input type="number" value={comisionProvPorcentaje}
                             onChange={(e) => setComisionProvPorcentaje(e.target.value)} />
                    </Col>
                    <Col md={2}>
                      <Label>Comisión %</Label>
                      <Input type="number" value={comisionPorcentaje}
                             onChange={(e) => setComisionPorcentaje(e.target.value)} />
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col md={4}>
                      <Label>Comisión Prov $</Label>
                      <Input type="text" value={fmt(calc.comisionProvMonto)} disabled />
                    </Col>
                    <Col md={4}>
                      <Label>Comisión $</Label>
                      <Input type="text" value={fmt(calc.comisionMonto)} disabled />
                    </Col>
                    <Col md={4}>
                      <Label>Total Pesos</Label>
                      <Input type="text" value={fmt(calc.totalPesos)} disabled />
                    </Col>
                  </Row>
                </>
              ) : (
                <>
                  <Row>
                    <Col md={4}>
                      <Label>Monto</Label>
                      <Input type="number" value={monto} onChange={(e) => setMonto(e.target.value)} />
                    </Col>
                    <Col md={4}>
                      <Label>Comisión Prov %</Label>
                      <Input type="number" value={comisionProvPorcentaje}
                             onChange={(e) => setComisionProvPorcentaje(e.target.value)} />
                    </Col>
                    <Col md={4}>
                      <Label>Comisión %</Label>
                      <Input type="number" value={comisionPorcentaje}
                             onChange={(e) => setComisionPorcentaje(e.target.value)} />
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col md={4}>
                      <Label>Comisión Prov $</Label>
                      <Input type="text" value={fmt(calc.comisionProvMonto)} disabled />
                    </Col>
                    <Col md={4}>
                      <Label>Comisión $</Label>
                      <Input type="text" value={fmt(calc.comisionMonto)} disabled />
                    </Col>
                    <Col md={4}>
                      <Label>Regresar</Label>
                      <Input type="text" value={fmt(calc.regresar)} disabled />
                    </Col>
                  </Row>
                </>
              )}
            </div>
          </div>

          <div className="total-bar">
            <span>Comisión total: <strong>{fmt(calc.comisionTotal)}</strong></span>
            <span style={{ marginLeft: 24 }}>
              {esTransferencia ? "Total Pesos: " : "Regresar: "}
              <strong>{fmt(esTransferencia ? calc.totalPesos : calc.regresar)}</strong>
            </span>
          </div>

          <div className="submit-bar">
            <Button color="success" onClick={guardar} disabled={!validaBoton}>
              <IcSave style={{ marginRight: 6 }} />
              Guardar Entrada
            </Button>
          </div>
        </div>
      ) : undefined}
    </>
  );
}

export default EntradasCreate;
